import * as React from "react";
import pageIds from "~/pageIds";
import type { CategorizedPageHelpRegistration, RenderRegistrationCardProps } from "../../../Registry/pageHelpRegistry";
import { CommonLibraryScriptModuleOverview } from "../../CommonComponents/CommonLibraryScriptModuleViews";
export const LibraryScriptModuleRegistration: CategorizedPageHelpRegistration = {
    page: pageIds.library.scriptModule,
    renderOverview: (renderProps: RenderRegistrationCardProps) => {
        return <CommonLibraryScriptModuleOverview />;
    },
    renderTopics: (renderProps: RenderRegistrationCardProps) => null,
};
